import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Award, Archive } from "lucide-react";
import { api } from "@/lib/api";
import { SectionHeader, Button, Loading, EmptyState, Tag } from "@/components/brand";
import { ChallengeFormDialog } from "@/components/ChallengeFormDialog";

export default function TrainerChallenges() {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const list = useQuery({ queryKey: ["trainer", "challenges"], queryFn: () => api("/trainer/challenges") });
  const create = useMutation({ mutationFn: (body) => api("/trainer/challenges", { method: "POST", body }), onSuccess: () => { setOpen(false); qc.invalidateQueries({ queryKey: ["trainer", "challenges"] }); toast.success("Challenge created"); }, onError: (e) => toast.error(e.message) });
  const archive = useMutation({ mutationFn: (cid) => api(`/trainer/challenges/${cid}/archive`, { method: "POST" }), onSuccess: () => qc.invalidateQueries({ queryKey: ["trainer", "challenges"] }) });

  return (
    <div data-testid="trainer-challenges-screen" className="space-y-5">
      <SectionHeader title="My Challenges" subtitle="Motivate your clients with private challenges." action="New challenge" onAction={() => setOpen(true)} testID="trainer-new-challenge" />
      {list.isLoading ? <Loading /> : (list.data ?? []).length === 0 ? (
        <EmptyState icon={Award} title="No challenges yet" subtitle="Create a challenge for your clients." />
      ) : (
        <div className="space-y-2">
          {(list.data ?? []).map((c) => (
            <div key={c.id} className="flex items-center gap-3 p-4 rounded-xl2 border border-divider">
              <div className="flex-1"><div className="font-display text-lg text-ink">{c.title}</div><div className="font-body text-xs text-mutedgrey">{c.participant_count} joined · {c.goal} {c.metric} · {c.reward_points} pts</div></div>
              <Tag label={c.archived ? "archived" : c.state} tone={c.archived ? "grey" : c.state === "active" ? "pink" : "dark"} />
              <button data-testid={`archive-${c.id}`} onClick={() => archive.mutate(c.id)} className="w-9 h-9 rounded-full bg-surface2 flex items-center justify-center text-mutedgrey hover:text-ink"><Archive size={16} /></button>
            </div>
          ))}
        </div>
      )}
      <ChallengeFormDialog open={open} onClose={() => setOpen(false)} onSubmit={(b) => create.mutate(b)} loading={create.isPending} allowCategory />
    </div>
  );
}
